<!-- 运维视图: 当前工单 -->
<template>
    <el-card class="box-card" @mouseenter.native="stopRefresh" @mouseleave.native="startRefresh">
        <div slot="header" class="clearfix">
            <span>当前工单任务</span>
        </div>
        <el-table :data="orders"
                height="437"
                stripe
                style="width: 100%">
            <el-table-column
                    prop="type"
                    label="工单类型"
            >
                <template slot-scope="scope">
                    <span>{{scope.row.typeName}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="count"
                    label="班次内需处理数量">
                <template slot-scope="scope">
                    <span>
                        <span v-if="scope.row.loading">
                            <i class="el-icon-loading">
                            </i>
                        </span>
                        <span v-else>
                            <span v-if="scope.row.count <= 0">{{scope.row.count}}</span>
                            <el-link v-else :disabled="!hasLogbook" @click="toLogbookDetailOther" type="primary">{{scope.row.count}}</el-link>
                        </span>
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="closeCount"
                    label="已完成数量">
                <template slot-scope="scope">
                    <span>
                        <span>{{scope.row.closeCount}}</span>
                    </span>
                </template>
            </el-table-column>
        </el-table>
    </el-card>
</template>

<script>
    import {
        findSimpleWorkOrderByLogbook,
        findSimpleChangeByLogbook,
        countIncidentByLogbook,
        findBillingUpDownCabinetByLogbook,
    } from "./operation-board-order-service";
    import {addParamsToUrl} from "@/util";
    import {RESOURCE_IP_PORT} from "@/api";

    // 是否启动定时刷新
    const TIMER_REFRESH_ENABLED = true;
    // 刷新间隔
    const REFRESH_INTERVAL = 120000;

    function setOrderStatistics(orderStatistics, count, closeCount, loading) {
        orderStatistics.count = count;
        orderStatistics.closeCount = closeCount;
        orderStatistics.loading = loading;
    }

    export default {
        name: "operation-board-order",
        props: {
            duty: {},
            params: {},
        },
        data() {
            let workOrderStatistics = {type: 'WORK', typeName: '作业工单', count: 0, closeCount: 0, loading: false,};
            let changeStatistics = {type: 'CHANGE', typeName: '变更工单', count: 0, closeCount: 0, loading: false,};
            let incidentStatistics = {type: 'INCIDENT', typeName: '事件工单（一级、二级）', count: 0, closeCount: 0, loading: false,};
            let upDownCabinetsStatistics = {type: 'UP_DOWN_CABINETS', typeName: '上下电工单', count: 0, closeCount: 0, loading: false,};
            return {
                refreshIntervalId: null,
                workOrderStatistics: workOrderStatistics,
                changeStatistics: changeStatistics,
                incidentStatistics: incidentStatistics,
                upDownCabinetsStatistics: upDownCabinetsStatistics,
                orders: [
                    workOrderStatistics,
                    changeStatistics,
                    incidentStatistics,
                    upDownCabinetsStatistics,
                ],
            };
        },
        computed: {
            hasLogbook() {
                let duty = this.duty;
                return duty != null && duty.logbook != null && duty.logbook.logbookId != null;
            },
        },
        watch: {
            params: {
                deep: true,
                immediate: true,
                handler() {
                    this.load();
                }
            }
        },
        methods: {
            load() {
                let params = this.params;
                let workOrderStatistics = this.workOrderStatistics;
                let changeStatistics = this.changeStatistics;
                let incidentStatistics = this.incidentStatistics;
                let upDownCabinetsStatistics = this.upDownCabinetsStatistics;

                if (params != null) {
                    setOrderStatistics(workOrderStatistics, 0, 0, true);
                    findSimpleWorkOrderByLogbook(params).then(workOrders => {
                        let workOrderCount = workOrders.length;
                        let workOrderCloseCount = workOrders.filter(e => e.status === 'CLOSE').length;
                        setOrderStatistics(workOrderStatistics, workOrderCount - workOrderCloseCount, workOrderCloseCount, false);
                    });
                    changeStatistics.loading = true;
                    setOrderStatistics(changeStatistics, 0, 0, true);
                    findSimpleChangeByLogbook(params).then(changes => {
                        let changeCount = changes.length;
                        let changeCloseCount = changes.filter(e => e.status === 'CLOSE').length;
                        setOrderStatistics(changeStatistics, changeCount - changeCloseCount, changeCloseCount, false);
                    });
                    setOrderStatistics(incidentStatistics, 0, 0, true);
                    countIncidentByLogbook(params, {levels: ['LEVEL1', 'LEVEL2']}).then(result => {
                        let incidentCount = result.totalCount;
                        let incidentCloseCount = result.closeCount;
                        setOrderStatistics(incidentStatistics, incidentCount - incidentCloseCount, incidentCloseCount, false);
                    });
                    setOrderStatistics(upDownCabinetsStatistics, 0, 0, true);
                    findBillingUpDownCabinetByLogbook(params).then(billingUpDownCabinets => {
                        let billingUpDownCabinetsCount = billingUpDownCabinets.length;
                        let billingUpDownCabinetsCloseCount = billingUpDownCabinets.filter(e => e.status === '60').length;
                        setOrderStatistics(upDownCabinetsStatistics, billingUpDownCabinetsCount - billingUpDownCabinetsCloseCount, billingUpDownCabinetsCloseCount, false);
                    });
                } else {
                    setOrderStatistics(workOrderStatistics, 0, 0, false);
                    setOrderStatistics(changeStatistics, 0, 0, false);
                    setOrderStatistics(incidentStatistics, 0, 0, false);
                    setOrderStatistics(upDownCabinetsStatistics, 0, 0, false);
                }
            },
            refresh() {
                this.load();
            },
            startRefresh() {
                if (TIMER_REFRESH_ENABLED) {
                    this.refreshIntervalId = setInterval(() => this.refresh(), REFRESH_INTERVAL);
                }
            },
            stopRefresh() {
                if (this.refreshIntervalId != null) {
                    clearInterval(this.refreshIntervalId);
                }
            },

            toLogbookDetailOther() {
                if (this.hasLogbook) {
                    let logbookId = this.duty.logbook.logbookId;
                    window.open(addParamsToUrl(`${process.env.VUE_APP_WEB_API}/athub/logbook/logbook.html`, {
                        m: 6501,
                        module: 'detailsOther',
                        id: logbookId,
                    }));
                }
            },
        },
        mounted() {
            this.startRefresh();
        },
    }
</script>

<style scoped>
    a.el-link.is-underline {
        text-decoration: none;
    }
</style>
